import { useCallback, useState } from 'react';
import { hooks } from '@febos-io/common';

export const useGetObjRecords = () => {
  const [data, setData] = useState({});

  const {
    callback: downloadContentCallback
  } = hooks.useDownloadContentFileFromS3PreSignedUrlCallback();

  const {
    callback,
    loading
  } = hooks.useRequestCallback(
    useCallback(async (request, url) => {
      const obj = await downloadContentCallback({ url });
      setData(obj);
      return obj;
    }, [downloadContentCallback])
  );

  return {
    loading,
    data,
    callback
  };
};

export default useGetObjRecords;
